import { Link } from "react-router-dom"
import { SubMenu } from "../style";

interface IbuttonMenu {
  titulo?: string
  direcao?: string
  nomeEstilo?: string
}

export function ButtonMenu(props: IbuttonMenu) {
  return (
    <>
      <Link to={props.direcao ?? ''}>
        <SubMenu>{props.titulo}</SubMenu>
      </Link>
    </>
  )
}
